
// EmailField.js

import React, { useState, useEffect } from 'react';

function EmailField({ value, onChange }) {
  const [email, setEmail] = useState(value);
  const [isValid, setIsValid] = useState(true);

  useEffect(() => {
    setEmail(value);
  }, [value]);

  const handleChange = (e) => {
    const value = e.target.value;
    setEmail(value);
    onChange(value);

    // Verificar se o e-mail é válido
    const isValidEmail = validateEmail(value);
    setIsValid(isValidEmail);
  };

  const validateEmail = (email) => {
    // Expressão regular para validar o formato do e-mail
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  return (
    <div>
      <input
        type="text"
        value={email}
        onChange={handleChange}
        placeholder="Digite o e-mail"
        style={{ width: '420px', height: '30px', marginBottom: '0px' }}
      />
      {!isValid && <p style={{ color: 'red' }}>E-mail inválido. Por favor, insira um e-mail válido.</p>}
    </div>
  );
}

export default EmailField;


//        style={{ width: '600px', height: '30px', borderColor: isValid ? 'inherit' : 'red' }} // Altera a cor da borda se o e-mail for inválido
